import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import VideoGallery from '../Projects/Gallery';

const ProjectImg = ({ filename, alt, fileNames }) => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 1366) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const image = data.images.edges.find((n) => n.node.relativePath.includes(filename));
      const imgs = [];
      if (fileNames) {
        data.images.edges.forEach((n) => {
          const img = fileNames.find((item) => n.node.relativePath === item.name);
          if (img) {
            const item = {
              original: n.node.childImageSharp.fluid.src,
              thumbnail: n.node.childImageSharp.fluid.src,
              srcSet: n.node.childImageSharp.fluid.srcSet,
              sizes: n.node.childImageSharp.fluid.sizes,
              order: img.order,
            };
            if (img.video) {
              item.video = true;
              item.embedUrl = img.url;
            }
            imgs.push(item);
          }
        });
      }

      imgs.sort((a, b) => a.order - b.order);
      if (imgs.length) {
        return <VideoGallery items={imgs} />;
      }

      if (!image) return null;

      const imageFluid = image.node.childImageSharp.fluid;
      return <Img alt={alt} fluid={imageFluid} />;
    }}
  />
);

ProjectImg.propTypes = {
  filename: PropTypes.string,
  alt: PropTypes.string,
};

export default ProjectImg;
